// adding some validations logic for news form
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export const FORM_NEWS_VALIDATIONS = {
  dataForm: {
    newsTitle: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(100)
    },
    newsTypeId: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(100)
    },
    newsDatePublished: {
      required
    },
    newsContent: {
      minLength: minLength(200),
    },
    newsAuthor: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(50)
    },
    newsSrc: {
      maxLength: maxLength(100)
    },
    newsLink: {
      maxLength: maxLength(255)
    },
    newsOverview: {
      required,
      minLength: minLength(25),
      maxLength: maxLength(255)
    }
  }
};



// WEBPACK FOOTER //
// ./src/validations/formNews.js